import React, { useEffect, useState } from "react";
import userImage from "../../../assets/images/user-img.jpg";
import { objIterate } from "../../../Functions/Utils";
import nodata from "../../../assets/images/no-data.png";
import { useLocation } from "react-router-dom";
function VerificationOutPut({ header, setIsVerified, responseData }) {
    const location = useLocation();
  const [response, setResponse] = useState();
  useEffect(() => {
    setResponse();
  }, []);

  const details = [
    { label: "Reference ID", value: responseData?.response_data?.data?.reference_id },
    { label: "Status", value: responseData?.response_data?.data?.status },
    { label: "Registration Number", value: responseData?.response_data?.data?.reg_no },
    { label: "Class", value: responseData?.response_data?.data?.class },
    { label: "Chassis", value: responseData?.response_data?.data?.chassis },
    { label: "Engine", value: responseData?.response_data?.data?.engine },
    { label: "Vehicle Manufacturer Name", value: responseData?.response_data?.data?.vehicle_manufacturer_name },
    { label: "Model", value: responseData?.response_data?.data?.model },
    { label: "Vehicle Color", value: responseData?.response_data?.data?.vehicle_colour },
    { label: "Type", value: responseData?.response_data?.data?.type },
    { label: "Stage Type", value: responseData?.response_data?.data?.norms_type },
    { label: "Body Type", value: responseData?.response_data?.data?.body_type },
    { label: "Owner", value: responseData?.response_data?.data?.owner },
    { label: "RC Status", value: responseData?.response_data?.data?.rc_status },
    { label: "Owner Father Name", value: responseData?.response_data?.data?.owner_father_name },
    { label: "Mobile Number", value: responseData?.response_data?.data?.mobile_number || 'N/A' },
    { label: "Owner Count", value: responseData?.response_data?.data?.owner_count },
    { label: "Status As On", value: responseData?.response_data?.data?.status_as_on },
    { label: "Registered Authority", value: responseData?.response_data?.data?.reg_authority },
    { label: "Registered Date", value: responseData?.response_data?.data?.reg_date },
    { label: "Vehicle Manufacturing Month & Year", value: responseData?.response_data?.data?.vehicle_manufacturing_month_year },
    { label: "RC Expiry Date", value: responseData?.response_data?.data?.rc_expiry_date },
    { label: "Vehicle Insurance Company Name", value: responseData?.response_data?.data?.vehicle_insurance_company_name || 'N/A' },
    { label: "Vehicle Tax Up to", value: responseData?.response_data?.data?.vehicle_tax_upto || 'N/A' },
    { label: "Vehicle Insurance Policy Number", value: responseData?.response_data?.data?.vehicle_insurance_policy_number || 'N/A' },
    { label: "Vehicle Insurance Up to", value: responseData?.response_data?.data?.vehicle_insurance_upto || 'N/A' },
    { label: "RC Financer", value: responseData?.response_data?.data?.rc_financer || 'N/A' },
    { label: "Vehicle Cubic Capacity", value: responseData?.response_data?.data?.vehicle_cubic_capacity || 'N/A' }
  ];

  const vehicleDetails = [
    { label: 'Gross Vehicle Weight', value: responseData?.response_data?.data?.gross_vehicle_weight || 'N/A' },
    { label: 'Unladen Weight', value: responseData?.response_data?.data?.unladen_weight || 'N/A' },
    { label: 'Vehicle Category', value: responseData?.response_data?.data?.vehicle_category || 'N/A' },
    { label: 'RC Standard Cap', value: responseData?.response_data?.data?.rc_standard_cap || 'N/A' },
    { label: 'Vehicle Cylinders No', value: responseData?.response_data?.data?.vehicle_cylinders_no || 'N/A' },
    { label: 'Vehicle Seat Capacity', value: responseData?.response_data?.data?.vehicle_seat_capacity || 'N/A' },
    { label: 'Vehicle Sleeper Capacity', value: responseData?.response_data?.data?.vehicle_sleeper_capacity || 'N/A' },
    { label: 'Vehicle Standing Capacity', value: responseData?.response_data?.data?.vehicle_standing_capacity || 'N/A' },
    { label: 'Wheelbase', value: responseData?.response_data?.data?.wheelbase || 'N/A' },
    { label: 'Vehicle Number', value: responseData?.response_data?.data?.vehicle_number || 'N/A' },
    { label: 'PUCC Number', value: responseData?.response_data?.data?.pucc_number || 'N/A' },
    { label: 'PUCC Up to', value: responseData?.response_data?.data?.pucc_upto || 'N/A' },
  ];
  
  const permitDetails = [
    { label: 'Permit Type', value: responseData?.response_data?.data?.permit_type || 'N/A' },
    { label: 'Permit Issue Date', value: responseData?.response_data?.data?.permit_issue_date || 'N/A' },
    { label: 'Permit Number', value: responseData?.response_data?.data?.permit_number || 'N/A' },
    { label: 'Permit Valid From', value: responseData?.response_data?.data?.permit_valid_from || 'N/A' },
    { label: 'Permit Valid Upto', value: responseData?.response_data?.data?.permit_valid_upto || 'N/A' },
    { label: 'Is Commercial', value: responseData?.response_data?.data?.is_commercial === true ? 'Yes' : responseData?.response_data?.data?.is_commercial === false ? 'No' : 'N/A' },
    { label: 'National Permit Number', value: responseData?.response_data?.data?.national_permit_number || 'N/A' },
    { label: 'National Permit Issued By', value: responseData?.response_data?.data?.national_permit_issued_by || 'N/A' },
    { label: 'NOC Details', value: responseData?.response_data?.data?.noc_details || 'N/A' },
    { label: 'Non Use Status', value: responseData?.response_data?.data?.non_use_status || 'N/A' },
    { label: 'Non Use From', value: responseData?.response_data?.data?.non_use_to || 'N/A' },
    { label: 'PUCC Up to', value: responseData?.response_data?.data?.pucc_upto || 'N/A' },
  ];

  const blacklistDetails = [
    { label: 'Blacklist Status', value: responseData?.response_data?.data?.blacklist_status || 'N/A' },
    { label: 'Blacklist Details', value: Array.isArray(responseData?.response_data?.data?.blacklist_details) && responseData.response_data.data.blacklist_details.length > 0 ? responseData.response_data.data.blacklist_details.join(', ') : 'N/A' },
  ];
  
  const challanDetails = [
    { label: 'Challan Details', value: Array.isArray(responseData?.response_data?.data?.challan_details) && responseData.response_data.data.challan_details.length > 0 ? responseData.response_data.data.challan_details.join(', ') : 'N/A' },
  ];
  
  const addressDetails = [
    { label: 'Address Line', value: responseData?.response_data?.data?.split_permanent_address?.address_line || 'N/A' },
    { label: 'Permanent Address', value: responseData?.response_data?.data?.permanent_address || 'N/A' },
    { label: 'State', value: Array.isArray(responseData?.response_data?.data?.split_permanent_address?.state) && responseData.response_data.data.split_permanent_address.state.length > 0 ? responseData.response_data.data.split_permanent_address?.state.join(', ') : 'N/A' },
    { label: 'City', value: Array.isArray(responseData?.response_data?.data?.split_permanent_address?.city) && responseData.response_data.data.split_permanent_address.city.length > 0 ? responseData.response_data.data.split_permanent_address?.city.join(', ') : 'N/A' },
    { label: 'Pin Code', value: responseData?.response_data?.data?.pincode || 'N/A' },
    { label: 'Country', value: Array.isArray(responseData?.response_data?.data?.split_permanent_address?.country) && responseData.response_data.data.split_permanent_address.country.length > 0 ? responseData.response_data.data.split_permanent_address?.country.join(', ') : 'N/A' },
  ];

 // Generic DetailRow Component
 const DetailRow = ({ label, value }) => (
    <div className="col-12 col-md-6 col-lg-4">
      <div className="row">
        <div className="col-12 col-md-6 my-2">
          <h2 className="font_13 font_600 my-0">{label}</h2>
        </div>
        <div className="col-12 col-md-6 my-2">
          <h2 className="font_12 font_500 my-0 text_master2">{value}</h2>
        </div>
      </div>
    </div>
  );

  const renderDetails = (details) => (
    details.map((item, index) => <DetailRow key={index} label={item.label} value={item.value} />)
  );
  return (
    <div className="">
      {/* <div
                class="mb-2 round_sm d-flex bg_master rounded-circle cursor-pointer align-items-center justify-content-center px_hover_1"
                onClick={() => setIsVerified(false)}
            >
                <i className="fas fa-chevron-left text-white me-1"></i>
            </div> */}
      {/* <div className="text-center">
                <h2 className="font_20 text_master2 fw-bold mb-3 text-uppercase">{header}</h2>
            </div> */}
      <div className="d-block">
        <div className="pt-2 box_height1 border border-2 bd_gray2 rounded h-100 overflow-auto scrollbar1 d-flex">
          <div
            className={`bg-white ${
              location.pathname === "/rc_verification"
                ? "aadhaar_data_head2"
                : "aadhaar_data_head"
            } br_10 m-auto pb-4 shadow_sm4`}
          >
            <div className="row align-items-center mx-0">
              {(responseData?.statusCode == 2031 ||
                responseData?.statusCode == 2041 ||
                responseData?.statusCode == 2009 ||
                responseData?.statusCode == 2202) && (
                <div className="pt-3">
                  <h2 className="font_16  fw-bold mb-3 text-center text-capitilize pt-2 mb-2">
                    Extracted data
                  </h2>
                </div>
              )}

              {responseData?.data?.photo_link && (
                <div className="col-12 col-md-auto ">
                  <div className="bd_gray2 text-center border_none border_md_end border_md_2 h-100">
                    <div className=""></div>
                    <div className="px-3 pt-1 font_13 bg_gray2">
                      <img
                        src={`data:image/jpeg;base64,${responseData?.data?.photo_link}`}
                        className=" object_fit_contain p-1 rounded w_150x h_150x"
                      />
                      <h2 className="font_11   mb-3 text-center text-capitilize pt-2 mb-2">
                        Extracted image
                      </h2>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-12 col-md ">
                <div className="px-3 pt-3 pb-1 font_13">
                  {/* using status code form api response here */}
                  {(responseData?.statusCode == 2031 ||
                    responseData?.statusCode == 2041 ||
                    responseData?.statusCode == 2009 ||
                    responseData?.statusCode == 2202) && (
                    <div className="row mb-2 d-none d-md-flex">
                      <div class="col-6">
                        <h2 className="font_18 font_600">Fields</h2>
                      </div>
                      <div className="col-6">
                        <h2 className="font_18 font_600 ">Values</h2>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    {objIterate(responseData?.data, [
                      "message",
                      "split_address",
                      "photo_link",
                    ]).length > 0 ? (
                      objIterate(responseData?.data, [
                        "message",
                        "split_address",
                        "photo_link",
                      ]).map((itm) => (
                        <div className="col-12 aadhaar_data  mb-2 py-2">
                          <div className="row">
                            <div className="col-12 col-md-6 text_dark1 fw_600 text-capitalize ">
                              {itm.key}
                            </div>
                            <div className="col-12 col-md-6 pt-1 pt-sm-0  mb-sm-0">
                              <div className="d-flex justify-content-start  ">
                                <span className="text_master2 fw_500 word_break text-start">
                                  {
                                    typeof itm.value === "boolean"
                                      ? itm.value
                                        ? "true"
                                        : "false"
                                      : itm.value
                                  }
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <>
                        {responseData?.status_code !== 200 && (
                          <div className="d-flex flex-column align-items-center mt-0 ">
                            <img
                              src={nodata}
                              className="no_data_thumbnail object_fit_contain"
                            />
                            <h4 className="text_gray7 font_16 mt-3">
                              {" "}
                              {responseData?.data?.message}
                            </h4>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {responseData?.status_code == 200 && (
              <>
                <div className="row align-items-center mx-0">
                  <div className="col-12">
                    <h1 className="bg_light4 font_18 font_600 my-0 px-3 py-2">
                      Basic Details
                    </h1>
                  </div>
                  {renderDetails(details)}
                  <h1 className="bg_light4 font_18 font_600 my-1 px-3 py-2">
                    Vehicle Details
                  </h1>
                  {renderDetails(vehicleDetails)}
                  <h1 className="bg_light4 font_18 font_600 my-1 px-3 py-2">
                    Address Details
                  </h1>
                  {renderDetails(addressDetails)}
                  <h1 className="bg_light4 font_18 font_600 my-1 px-3 py-2">
                    Permit Details
                  </h1>
                  {renderDetails(permitDetails)}
                  <h1 className="bg_light4 font_18 font_600 my-1 px-3 py-2">
                    Blacklist Details
                  </h1>
                  {renderDetails(blacklistDetails)}
                  <h1 className="bg_light4 font_18 font_600 my-1 px-3 py-2">
                    Challan Details
                  </h1>
                  {renderDetails(challanDetails)}
                </div>
              </>
            )}
          </div>
        </div>
        <div>
          <h2 className="font_14 text-center pt-2">
            Want to Verify another?{" "}
            <span
              className="fw_500 text_master2 cursor-pointer"
              onClick={() => {
                setIsVerified(false);
              }}
            >
              Click Here
            </span>{" "}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default VerificationOutPut;
